import styled from 'styled-components';
import { Stack } from '@ardoq/layout';
import { SidebarMenuItem, SidebarMenuItemProps } from './SidebarMenuItem';

const MenuWrapper = styled(Stack)``;

export const SIDEBAR_MENU_MENU_SELECTOR = MenuWrapper.toString();

export type MenuOptionProps = SidebarMenuItemProps;

type SidebarMenuMenuProps = {
  options?: MenuOptionProps[];
};

export const SidebarMenuMenu = ({ options = [] }: SidebarMenuMenuProps) => {
  return (
    <MenuWrapper gap="small">
      {options.map(
        (
          {
            label,
            onClick,
            isDisabled,
            dataClickId,
            dataTestId,
            leftContent,
            rightContent,
            isSelected,
            ariaCurrent,
          },
          index
        ) => (
          <SidebarMenuItem
            key={index}
            onClick={onClick}
            isDisabled={isDisabled}
            dataClickId={dataClickId}
            dataTestId={dataTestId}
            isSelected={isSelected}
            ariaCurrent={ariaCurrent}
            leftContent={leftContent}
            rightContent={rightContent}
            label={label}
          />
        )
      )}
    </MenuWrapper>
  );
};
